import { render, staticRenderFns } from "./DownloadBtn.vue?vue&type=template&id=5a87a06b&"
import script from "./DownloadBtn.vue?vue&type=script&lang=js&"
export * from "./DownloadBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports